/**
 * Canonical list of property amenities shown during onboarding (listing page)
 * and edited from the dashboard (Settings). Keep this as the single source of
 * truth so the two surfaces never drift.
 */
const amenitiesOptions = [
  "Free Breakfast","Free Parking", "Pet Friendly", "Air Conditioning","Laundry","Newspaper","Room Service","Smoke Detector","Swimming Pool","Wifi",
  "Lounge","Reception","Bar","Restaurant","Luggage Assistance","Wheelchair Accessibility","Gym/Fitness Centre",
  "CCTV","Fire Extinguishers","First-aid Services","Airport Transfers","Basic Facilities","Elevator/Lift",
  "Housekeeping","Kitchen/Kitchenette","LAN","Power Backup","Genset","Refrigerator","Umbrellas","Washing Machine",
  "Laundromat","EV Charging Station","Driver's Accommodation","General Services","Bellboy Service","Caretaker",
  "Concierge","Multilingual Staff","Luggage Storage","Specially Abled Assistance","Wake-up Call/Service",
  "Butler Services","Doctor on Call","Medical Centre","Pool/Beach Towels","Outdoor Activities and Sports","Beach",
  "Bonfire","Golf","Kayaks","Outdoor Sports (Cricket, Volleyball, Basketball, Tennis, Badminton)","Swings",
  "Rock Climbing","Archery","Hiking","Squash","Snorkelling","Telescope","Water Sports","Water Park","Diving",
  "Canoeing","Skiing","Jungle Safari","Cycling","Common Areas","Balcony/Terrace","Fireplace",
  "Indoor Seating Area","Lawn","Library","Sun Deck","Verandah","Jacuzzi","Prayer Room","Living Room",
  "Outdoor Furniture","Picnic Area","Game Room","Sitout Area","Bonfire Pit","Food and Drink","Barbecue","Café",
  "Coffee Shop","Dining Area","Kid's Menu","Bakery","Breakfast","Food Options Available",
  "Business Center and Conferences","Banquet","Business Center","Conference Room","Photocopying","Fax Service","Printer"
];

export default amenitiesOptions;
